import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const ListLogsAuditUser = Loadable(lazy(() => import('views/user/LogsView/LogAuditView')));

const LogsRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/list-logs-audit-view',
            element: <ListLogsAuditUser />
        },        
    ]
};

export default LogsRoutes;